import StoreMix from '@lottery.admin.2.0/mixin/store.js'
export default StoreMix